<template>
  <v-container fluid>
    <v-tab-item class="pb-12" eager>
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @is-valid="$emit('step-observer', { step: 0, complete: $event })" />
        <div class="display-1 font-weight-normal mb-6 text-center">Vamos começar preenchendo as informações básicas</div>
        <v-row class="mx-auto">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required|max:255">
              <v-text-field
                id="titulo-conciliacao"
                v-model="titulo"
                class="my-0"
                label="Título"
                outlined
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col cols="11">
            <validation-provider id="flexibilidade-conciliacao" v-slot="{ errors }" rules="required">
              <v-select
                v-model="flexibilidade"
                class="my-0"
                :items="['Flexível', 'Rígida', 'Parcial']"
                label="Flexibilidade"
                outlined
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="1" class="pl-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  id="dialog-flexibilidade-conciliacao"
                  class="pt-4"
                  size="28"
                  v-bind="attrs"
                  v-on="on"
                  @click.close="dialogFlexibilidade = true"
                >
                  mdi-progress-question
                </v-icon>
              </template>
              <span>Clique aqui para obter um informativo sobre as diferenças das flexibilidades</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col cols="12">
            <v-expansion-panels v-model="panels" accordion multiple>
              <v-expansion-panel id="conciliacao-editar-rodadas">
                <v-expansion-panel-header style="font-weight: 300; font-size: 15px">Editar Rodadas</v-expansion-panel-header>
                <v-expansion-panel-content class="expansion-panel-padding-x-clear">
                  <rodadas-conciliacoes
                    v-model="rodadas"
                    :atributosList="atributosList"
                    :tipoConciliacao="tipoConciliacao"
                    atributosCols="12"
                    atributosSm="2"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="conciliacao-editar-arquivo-resultado">
                <v-expansion-panel-header style="font-weight: 300; font-size: 15px">
                  Editar Arquivo Resultado
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-checkbox
                    v-for="aba in abasArquivoResultado"
                    :key="aba.value"
                    v-model="abasParaDownload"
                    dense
                    multiple
                    hide-details
                    class="d-inline-flex mx-1 my-0 pa-0 shrink"
                    :label="aba.label"
                    :value="aba.value"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col id="conciliacao-atributos-coringa" cols="12" class="pl-2">
            <div class="d-inline-flex">
              <v-checkbox v-model="atributosCoringa" class="my-0" label="Habilitar Atributos Coringa?" />
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    id="conciliacao-atributos-coringa-help"
                    class="mb-5 ml-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="dialogAtributosCoringa = true"
                  >
                    mdi-progress-question
                  </v-icon>
                </template>
                <span>Clique aqui para obter um informativo sobre habilitar atributos coringa</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>
    <template v-for="(item, key) in partidaReferencia">
      <v-tab-item :key="key" :class="`pb-12 tab-${key}-conciliacao`" eager>
        <validation-observer v-slot="{ valid }">
          <validation-helper
            :interceptor="valid"
            @is-valid="
              $emit('step-observer', {
                step: key === 'partida' ? 1 : 2,
                complete: $event
              })
            "
          />
          <div :id="`conciliacao-base-de-${key}`">
            <v-row align="center" class="mx-auto">
              <v-col cols="12">
                <validation-provider :id="`selecionar-origem-${key}-conciliacao`" v-slot="{ errors }" rules="required">
                  <v-select
                    v-model="item.origem"
                    :items="['ARQUIVO', 'RELATORIO']"
                    :label="key == 'partida' ? 'Origem Base de Partida' : 'Origem Base de Referência'"
                    outlined
                    :error-messages="errors"
                    @change="clearInputsOrigem(item.origem)"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row align="center" class="mx-auto">
              <v-col v-show="item.origem" cols="12" class="mb-4">
                <v-alert dense outlined type="info" color="blue" class="pa-2">
                  <div v-if="item.origem == 'RELATORIO'">
                    O Relatório selecionado deve conter os campos
                    <b>ID</b>
                    e
                    <b>QTD</b>
                    .
                    <br />
                    Obs: O campo
                    <b>QTD</b>
                    pode conter os nome
                    <b>QTD Somatório</b>
                    ,
                    <b>QTD MCPSE</b>
                    ou
                    <b>QTD</b>
                    para ser validado.
                    <br />
                    Obs²: O campo
                    <b>ID</b>
                    pode conter os nomes
                    <b>ID</b>
                    ,
                    <b>COD_ID</b>
                    ,
                    <b>IMOBILIZADO</b>
                    ou
                    <b>SUBNÚMERO</b>
                    para ser validado.
                  </div>

                  <div v-if="item.origem == 'ARQUIVO'">
                    O arquivo selecionado deve conter os campos
                    <b>ID</b>
                    e
                    <b>QTD</b>
                    .
                    <br />
                    Obs: O campo
                    <b>QTD</b>
                    pode conter os nome
                    <b>QTD Somatório</b>
                    ,
                    <b>QTD MCPSE</b>
                    ou
                    <b>QTD</b>
                    para ser validado.
                    <br />
                    Obs²: O campo
                    <b>ID</b>
                    pode conter os nomes
                    <b>ID</b>
                    ,
                    <b>COD_ID</b>
                    ,
                    <b>IMOBILIZADO</b>
                    ,
                    <b>EI</b>
                    ou
                    <b>SUBNÚMERO</b>
                    para ser validado.
                    <link-download-arquivo-modelo :tipoConciliacao="tipoConciliacao" />
                  </div>
                </v-alert>
              </v-col>
            </v-row>
            <v-row v-if="item.origem == 'RELATORIO'" align="center" class="mx-auto">
              <v-col cols="12">
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-text-field
                    :id="`selecionar-relatorio-${key}-conciliacao`"
                    v-model="item.relatorioNome"
                    label="Relatorio"
                    placeholder="Selecione uma relatório"
                    readonly
                    outlined
                    :success="item.headerValido && item.relatorioNome != ''"
                    :error-messages="errors"
                    @focus.close="dialogRelatorio = true"
                  />
                </validation-provider>
              </v-col>
              <validation-provider rules="required">
                <input type="hidden" :name="`valida-header-relatorio-${key}`" :value="item.headerValido ? 'OK' : ''" />
              </validation-provider>
            </v-row>
            <v-row v-if="item.origem == 'ARQUIVO'" align="center" class="mx-auto">
              <v-col cols="12" class="pl-2">
                <validation-provider :id="`selecionar-arquivo-${key}-conciliacao`" v-slot="{ errors }" rules="required">
                  <v-file-input
                    v-model="item.arquivo"
                    label="Arquivo CSV"
                    placeholder="Selecione um arquivo CSV"
                    outlined
                    accept=".csv, .zip"
                    :show-size="!item.fakeFile"
                    truncate-length="30"
                    :loading="item.uploading"
                    loader-height="4"
                    :success="(item.arquivoId && item.arquivo && item.headerValido) || item.fakeFile ? true : false"
                    :error-messages="errors"
                    @change="uploadNewFile(item)"
                  />
                </validation-provider>
                <validation-provider rules="required">
                  <input
                    type="hidden"
                    :name="`valida-upload-${key}`"
                    :value="(item.arquivoId && item.headerValido) || item.fakeFile ? 'OK' : ''"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <parametros-arquivo-csv
              v-if="item.origem == 'ARQUIVO'"
              :id="`campos-arquivo-${key}-conciliacao`"
              :delimitador.sync="item.delimitador"
              :involucro.sync="item.involucro"
              :escape.sync="item.escape"
            />
          </div>
          <v-row align="center" class="mx-auto">
            <v-col cols="12">
              <v-expansion-panels v-model="item.panels" accordion>
                <v-expansion-panel :id="`conciliacao-editar-mapeamento-${key}`">
                  <v-expansion-panel-header style="font-weight: 300; font-size: 15px">Editar Mapeamento</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <tbody>
                          <tr v-for="(value, coluna) in item.mapeamento" :key="coluna">
                            <td>
                              <strong class="d-inline-flex">
                                {{ coluna | replaceUnderscoresWithSpace }}
                                <v-icon
                                  v-if="['ID', 'QTD', ...prioridades].includes(coluna)"
                                  size="9"
                                  class="mb-1 pl-1"
                                  color="error"
                                >
                                  mdi-asterisk
                                </v-icon>
                              </strong>
                            </td>
                            <td style="max-width: 125px">
                              <validation-provider
                                v-slot="{ errors }"
                                :rules="['ID', 'QTD', ...prioridades].includes(coluna) ? 'required' : undefined"
                              >
                                <v-select
                                  v-model="item.mapeamento[coluna]"
                                  :items="item.header"
                                  clearable
                                  dense
                                  no-data-text="Nenhum campo disponível."
                                  :hide-details="errors.length ? false : true"
                                  :error="['ID', 'QTD', ...prioridades].includes(coluna) && !item.mapeamento[coluna]"
                                  :error-messages="errors"
                                />
                              </validation-provider>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </validation-observer>
      </v-tab-item>
    </template>
    <dialog-flexibilidade :activated.sync="dialogFlexibilidade" />
    <dialog-atributos-coringa :activated.sync="dialogAtributosCoringa" />
    <dialog-seletor-relatorio :activated.sync="dialogRelatorio" @selected="setRelatorio($event)" />
  </v-container>
</template>

<script>
  import conciliacoesWizardTabsMixins from '@/mixins/conciliacoes/conciliacoesWizardTabsMixins.js';

  export default {
    components: {
      RodadasConciliacoes: () => import('@/components/power-ups/conciliacoes/RodadasConciliacoes.vue'),
      DialogFlexibilidade: () => import('@/components/power-ups/conciliacoes/DialogFlexibilidade.vue'),
      DialogAtributosCoringa: () => import('@/components/power-ups/conciliacoes/DialogAtributosCoringa.vue'),
      DialogSeletorRelatorio: () => import('@/components/general/seletores/DialogSeletorRelatorio.vue'),
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue'),
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue'),
      LinkDownloadArquivoModelo: () => import('@/components/power-ups/conciliacoes/LinkDownloadArquivoModelo.vue')
    },
    mixins: [conciliacoesWizardTabsMixins],

    data: () => ({
      tipoConciliacao: 'CUSTOM',
      atributosList: [
        'TUC',
        'ODI',
        'TI',
        'A1',
        'A2',
        'A3',
        'A4',
        'A5',
        'A6',
        'UAR',
        'IDUC',
        'Inventario',
        'Obra',
        'Material',
        'Data',
        'Generico_1',
        'Generico_2',
        'Generico_3'
      ],
      panels: 0,
      precisaOrganizarPrioridades: false
    }),

    created() {
      if (this.$route.params.id) this.fillFields();
    },

    methods: {
      organizarPrioridades() {
        if (this.precisaOrganizarPrioridades) {
          let atributos = [];
          this.rodadas.forEach((arr) => (atributos = atributos.concat(atributos, arr.valores)));
          this.prioridades = Array.from(new Set(atributos));
        }

        this.precisaOrganizarPrioridades = false;
      }
    },

    watch: {
      rodadas() {
        this.precisaOrganizarPrioridades = true;
      },
      tab(newTab) {
        if (newTab !== 0 && this.precisaOrganizarPrioridades) {
          this.organizarPrioridades();
        }
      }
    }
  };
</script>

<style>
  .ghost {
    opacity: 0.5;
  }
</style>
